import * as routes from '@/constants/routes';
import * as subjects from '@/constants/subjects';
import * as actions from '@/constants/actions';
import { SENT, SCHEDULED, DRAFTS } from '@/constants/entityStatuses';
import { canAbility } from './middleware';
import RouterViewPassThrough from './RouterViewPassThrough';

export default {
  path: '/announcements',
  name: routes.ANNOUNCEMENTS_PARENT,
  redirect: { name: routes.ANNOUNCEMENTS_SENT },
  component: RouterViewPassThrough,
  children: [
    {
      path: '/announcements',
      name: routes.ANNOUNCEMENTS_SENT,
      component: () => import('@/views/Announcements/index.vue'),
      meta: {
        middleware: [canAbility([actions.READ], subjects.ANNOUNCEMENTS)],
      },
      props: { status: SENT },
    },
    {
      path: 'scheduled',
      name: routes.ANNOUNCEMENTS_SCHEDULED,
      component: () => import('@/views/Announcements/index.vue'),
      meta: {
        middleware: [canAbility([actions.READ], subjects.ANNOUNCEMENTS)],
      },
      props: { status: SCHEDULED },
    },
    {
      path: 'drafts',
      name: routes.ANNOUNCEMENTS_DRAFTS,
      component: () => import('@/views/Announcements/index.vue'),
      meta: {
        middleware: [canAbility([actions.READ], subjects.ANNOUNCEMENTS)],
      },
      props: { status: DRAFTS },
    },
    {
      path: 'create',
      name: routes.ANNOUNCEMENTS_CREATE,
      component: () => import('@/views/Announcements/Modify.vue'),
      meta: {
        middleware: [canAbility([actions.UPDATE], subjects.ANNOUNCEMENTS)],
      },
      props: () => ({ isEdit: false }),
    },
    {
      path: ':id/edit',
      name: routes.ANNOUNCEMENTS_EDIT,
      component: () => import('@/views/Announcements/Modify.vue'),
      meta: {
        middleware: [canAbility([actions.UPDATE], subjects.ANNOUNCEMENTS)],
      },
      props: route => ({ isEdit: true, id: Number(route.params.id) || -1 }),
    },
    {
      path: ':id',
      name: routes.ANNOUNCEMENTS_DETAILED,
      component: () => import('@/views/Announcements/Detailed.vue'),
      meta: {
        middleware: [canAbility([actions.READ], subjects.ANNOUNCEMENTS)],
      },
      props: route => ({ id: Number(route.params.id) }),
    },
  ],
};
